import React from "react";
import PropTypes from "prop-types";
import useField from "../hooks/use-field";
import {observer} from "mobx-react";
import Select from "../simpletons/Select";
import Checkbox from "../simpletons/Checkbox";
import {Case} from "@morningtrain/react-resources";

function Switch(props) {

    const field = useField(props);

    let Switcher = (props.type === 'select') ? Select : Checkbox;

    return (
        <React.Fragment>
            <Switcher {...props} onChange={field.onChange} />
            <Case value={field.value} >
                {props.children}
            </Case>
        </React.Fragment>
    );
}

Switch.defaultProps = {
    ...useField.defaultProps,
    type: 'select',
};

Switch.propTypes = {
    ...useField.propTypes,
    type: PropTypes.string,
};

export default observer(Switch);
